import { Link as ChakraLink, LinkProps } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

type CustomLinkProps = {
    children: React.ReactNode
    href: string
    [rest: string]: any
} & LinkProps

const CustomLink = ({ href, children, ...rest }: CustomLinkProps) => {
    return (
        <ChakraLink color={'brand.200'} as={RouterLink} to={href} {...rest}>
            {children}
        </ChakraLink>
    )
}

export default CustomLink
